import { isObjEmpty } from '@app/helpers/objHelper';

export const unique = (array: any[]) =>
  array.filter(function (item, pos, self) {
    return self.indexOf(item) == pos;
  });

export const groupBy = (collection: any[], property: string): any[] => {
  const values = [];
  const result = [];

  for (const item of collection) {
    const val = item[property];
    const index = values.indexOf(val);

    if (index > -1 && !isObjEmpty(val, true)) {
      result[index].push(item);
    } else {
      values.push(val);
      result.push([item]);
    }
  }
  return result;
};


export const mapToOptions = (array?: any[], value: string, label: string) => {

  if (isObjEmpty(array)) return [];

  return array.map((item) => {
    return {
      value: item[value],
      text: item[label]
    }
  });
}
